import DashboardLayout from "src/pages/Dashboard/Layout/DashboardLayout.vue";
const DashboardHeader = () =>
  import(
    /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Dashboard/DashboardHeader.vue"
  );
import DefaultHeader from "src/pages/Dashboard/DefaultHeader";

// Dashboard pages
const Dashboard = () =>
  import(
    /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Dashboard/Dashboard.vue"
  );
//import Upload from "src/pages/Dashboard/Upload.vue";


const routes = [
  {
    path: "/",
    redirect: "/dashboard",
    name: "Home"
  },
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/dashboard",
    name: "Dashboard",
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        components: { default: Dashboard, header: DashboardHeader }
      },
      // {
      //   path: "upload",
      //   name: "Upload",
      //   components: { default: Upload, header: DefaultHeader }
      // },
    ]
  },
  { path: "*",  redirect: '/dashboard' }
];

export default routes;
